import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";

import {useIsMounted} from "../../../misc/helperHooks";
import {getLookList, getSameColorFeatures} from "../../look/lookNavigation/lookFunctions";
import {checkIfLookFeaturesReceived} from "../../../api/look-api";
import {setGroheSameColorActiveFeature, setGroheSameColorCheckboxApplied} from "../../../actions/groheFunctions";


export default function useFeaturesColorMatch(featureGroup = null) {

  const filterGroups = useSelector((s) => s.filterState.filterGroups);

  const dispatch = useDispatch();

  const [sameColorFeatures, setSameColorFeatures] = useState([]);
  const [currentColorFeatures, setCurrentColorFeatures] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const isMounted = useIsMounted();

  const checkMatchingFeatures = async () => {
    if (!featureGroup?.activeFeature) {
      return null
    }
    if (featureGroup && !featureGroup.allFeaturesReceived) {
      setIsLoading(true);
    }
    const featureGroups = getLookList(true);
    // console.log("useFeaturesColorMatch featureGroups", featureGroups);
    if (featureGroups) {
      let promises = [];
      for (let parentObject of featureGroups) {
        if (parentObject.featureGroup && !parentObject.featureGroup.allFeaturesReceived && !parentObject.featureGroup.requestInProgress) {
          // we have to request features on th background before the colors are applied, so we can match properly
          promises.push(checkIfLookFeaturesReceived(parentObject.featureGroup).then(() => {
            if (parentObject.featureGroup.partId === featureGroup.partId) {
              dispatch(updateNavigationCount()) // if it was launched faster - update navigation list
            }
          }));
        }
      }
      await Promise.all(promises);
      setIsLoading(false);
    }
    if (featureGroup.activeFeature) {
      const {sameColorFeatures, differentColorFeatures} = getSameColorFeatures(featureGroup.activeFeature, filterGroups);
      dispatch(setGroheSameColorCheckboxApplied(false));
      if (isMounted()) {
        setSameColorFeatures(sameColorFeatures); // same color but different feature groups
        setCurrentColorFeatures(differentColorFeatures); // same color but different feature groups
      }
      dispatch(setGroheSameColorActiveFeature(featureGroup.activeFeature)); // same color but different feature groups
    }
  }

  useEffect(() => {
    checkMatchingFeatures();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [featureGroup, featureGroup?.activeFeature]);
  // }, [featureGroup, featureGroup?.activeFeature, navigationCount]);

  return {sameColorFeatures, currentColorFeatures, isLoading};
}
